import { z } from 'zod';

export const CurrentTokenSchema = z.object({
  currentTokenId: z.string().min(1, 'Current token ID cannot be empty'),
});

export type ICurrentTokenDto = z.infer<typeof CurrentTokenSchema>;
